export default __webpack_public_path__ + "static/media/upload.e6262ccc.svg";